import { render, staticRenderFns } from "./principal-management.vue?vue&type=template&id=420caca1"
import script from "./principal-management.vue?vue&type=script&lang=ts"
export * from "./principal-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports